import { Ellipsis } from "@visiblethread/react-components";
import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";
import { string } from "prop-types";
import { memo } from "react";
import { useSelector } from "react-redux";
import { selectSelectedCollectionName } from "slices/collections/selectors";
import { selectCurrentContractName } from "slices/contracts/detail/selectors";
import { selectCurrentMiscAnalysisName } from "slices/miscAnalysis";
import { selectOpportunityTitle } from "slices/opportunity/summary/selectors";
import { selectProposalTitle } from "slices/proposals/proposal/selectors";
import { selectFolderName } from "slices/workspace/selectors";

const selectors = {
  [UPLOAD_ENTITY_TYPES.OPPORTUNITY]: selectOpportunityTitle,
  [UPLOAD_ENTITY_TYPES.CONTRACT]: selectCurrentContractName,
  [UPLOAD_ENTITY_TYPES.DOC_STYLE_TEMPLATES]: () => "MS Word templates",
  [UPLOAD_ENTITY_TYPES.FOLDER]: selectFolderName,
  [UPLOAD_ENTITY_TYPES.PROPOSAL]: selectProposalTitle,
  [UPLOAD_ENTITY_TYPES.COLLECTIONS]: selectSelectedCollectionName,
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS]: selectCurrentMiscAnalysisName,
};

const defaultSelector = () => "Current location";

const TargetName = ({ target }) => {
  const selector = selectors[target] || defaultSelector;
  const targetName = useSelector(selector);

  return <Ellipsis text={targetName} />;
};

TargetName.propTypes = {
  target: string,
};

export default memo(TargetName);
